import { Box, Chip, styled } from '@mui/material';
import {
  DataGrid,
  type GridColDef,
  type GridPaginationModel,
} from '@mui/x-data-grid';
import { EmployeeMenu } from './employee-menu';
import type { Employee } from '@/data/employees/interfaces';

const customLocaleText = {
  columnMenuFilter: 'Filtrar',
  columnMenuSelectAll: 'Selecionar todos',
  columnMenuUnselectAll: 'Desmarcar todos',
  columnMenuItemsPerPage: 'Itens por página:',
  columnMenuSortAsc: 'Ordenar crescente',
  columnMenuSortDesc: 'Ordenar decrescente',
  columnMenuHideColumn: 'Ocultar coluna',
  columnMenuManageColumn: 'Gerenciar colunas',
  noRowsLabel: 'Nenhum usuário encontrado',
};

const CustomChip = styled(Chip)({
  '&.inactive': {
    backgroundColor: '#E3FAFF',
    color: '#004959',
  },
  '&.registered': {
    backgroundColor: '#E3F7EC',
    color: '#0F331F',
  },
  '&.deleted': {
    backgroundColor: '#FFEFF5',
    color: '#65002B',
  },
});

const statusUser = (user: Employee) => {
  if (user?.deleted_at !== null) return 'deleted';
  if (user?.bloqueado) return 'blocked';
  return 'registered';
};

interface EmployeeListProps {
  employees: Employee[];
  pageState: {
    isLoading: boolean;
    data: Employee[];
    total: number;
    page: number;
    pageSize: number;
  };
  onPaginationModelChange: (newPage: GridPaginationModel) => void;
}

const statusUserLabel = {
  deleted: 'Excluído',
  blocked: 'Bloqueado',
  registered: 'Cadastrado',
};

export const EmployeeList = ({
  employees,
  pageState,
  onPaginationModelChange,
}: EmployeeListProps) => {
  const columns: GridColDef<Employee>[] = [
    {
      field: 'name',
      headerName: 'Nome',
      width: 350,
      valueGetter: (params) => params.row.nome,
    },
    {
      field: 'email',
      headerName: 'E-mail',
      width: 350,
      valueGetter: (params) => params.row.email,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      renderCell: (params) => (
        <CustomChip
          label={statusUserLabel[statusUser(params.row)]}
          className={statusUser(params.row)}
        />
      ),
    },
    {
      field: 'user',
      headerName: 'Ação',
      sortable: false,
      renderCell: (params) => <EmployeeMenu employee={params.row} />,
      width: 50,
    },
  ];

  return (
    <Box sx={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={employees}
        rowCount={pageState.total}
        loading={pageState.isLoading}
        pagination
        paginationMode="server"
        onPaginationModelChange={(newPage) => {
          onPaginationModelChange(newPage);
        }}
        paginationModel={{
          page: pageState.page,
          pageSize: pageState.pageSize,
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        localeText={customLocaleText}
        columns={columns}
        disableRowSelectionOnClick
      />
    </Box>
  );
};
